import { render, staticRenderFns } from "./ProductSelectT1.vue?vue&type=template&id=954e411a&"
import script from "./ProductSelectT1.vue?vue&type=script&lang=js&"
export * from "./ProductSelectT1.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelectT1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports